import type { ScreenConfig } from "@signage/shared";

// A screen must never sit on a blank/loading screen if it has ever
// successfully loaded a config before — cache the last-known-good config
// (and the last-applied command timestamps) in localStorage so a cold boot
// with no network still renders something immediately.

const configKey = (screenId: string) => `signage.config.${screenId}`;
const commandKey = (screenId: string) => `signage.lastCommandAt.${screenId}`;

export function readCachedConfig(screenId: string): ScreenConfig | null {
  try {
    const raw = localStorage.getItem(configKey(screenId));
    return raw ? (JSON.parse(raw) as ScreenConfig) : null;
  } catch {
    return null;
  }
}

export function writeCachedConfig(screenId: string, config: ScreenConfig): void {
  try {
    localStorage.setItem(configKey(screenId), JSON.stringify(config));
  } catch {
    // Storage full/unavailable — non-fatal, just skip caching.
  }
}

export function readLastCommandAt(screenId: string): string | null {
  try {
    return localStorage.getItem(commandKey(screenId));
  } catch {
    return null;
  }
}

export function writeLastCommandAt(screenId: string, iso: string): void {
  try {
    localStorage.setItem(commandKey(screenId), iso);
  } catch {
    // ignore
  }
}
